<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/timbuk2/products/*', { eager: true });

useHead({});

const products = [
	{
		title: 'Eco Packable Travel Tote',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-packable-travel-tote-open.png'].default
	},
	{
		title: 'Eco Player Duffel',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-player-duffel.webp'].default
	},
	{
		title: 'Eco Tuck Laptop Backpack',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-tuck-laptop-backpack.webp'].default
	},
	{
		title: 'Eco Classic Messenger Bag',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-classic-messenger-bag.webp'].default
	},
	{
		title: 'Eco Slacker Chest Pack',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-slacker-chest-pack.webp'].default
	},
	{
		title: 'Canvas Shopper Tote Bag',
		src: imagesGlob['../../images/brands/timbuk2/products/canvas-shopper-tote-bag.webp'].default
	},
	{
		title: 'Eco Parkside Laptop Backpack',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-parkside-laptop-backpack.png'].default
	},
	{
		title: 'Eco Stealth Folio Organizer',
		src: imagesGlob['../../images/brands/timbuk2/products/eco-stealth-folio-organizer.png'].default
	},
	{
		title: 'Deluxe Eco Division Laptop Backpack',
		src: imagesGlob['../../images/brands/timbuk2/products/deluxe-eco-division-laptop-backpack.webp'].default
	},
]
</script>

<template lang="pug">
.page.page--brand.NAME
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/timbuk2/logo.png')
				h1 Custom Timbuk2
			.image
				img(src='@static/images/brands/timbuk2/hero.webp' alt="Two people on a mountain trail, one in an olive hooded jacket with a backpack, the other in a brown jacket and gray cap carrying a black Timbuk2 messenger bag.")
	section.section.section--subhero
		.section__content
			.copy
				h3 BUILT TO GO FURTHER
				p Born in San Francisco’s Mission District by a bike messenger, Custom Timbuk2 by Swagger brings 30+ years of street-smart design. Built tough and made to be repaired, these bags keep up with urban explorers, creatives, and commuters alike. From rugged backpacks to everyday essentials, every piece blends function with sleek style.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Timbuk2 ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="timbuk2")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/timbuk2/banner.jpg' alt="Close-up of two people wearing custom Timbuk2 roll-top backpacks in lime, lavender, and sky blue.")
			.section__content
				.copy
					h2 CUSTOM, BY DESIGN
					p Timbuk2 believes gear should be as unique as the person carrying it. Their Custom Bag Program makes that possible, offering endless ways to design a bag that reflects your brand’s style and purpose. From bold colors to personalized features, customization is built into their DNA. With billions of combinations and an intuitive design experience, Timbuk2 turns functional bags into brand-defining statements.
		
		section.section.section--foot
			.bg
			.section__content
				.pack
					.item
						img(src='@static/images/brands/timbuk2/pack-1.jpg' alt="Close up of custom timbuk2 backpack in royal, teal, pink, and black")
					.item
						img(src='@static/images/brands/timbuk2/pack-2.png' alt="Close-up of a person opening a custom Timbuk2 backpack, revealing a note inside that reads “Keeping junk out of the dump since 1989.”")
					.item
						img(src='@static/images/brands/timbuk2/pack-3.jpg' alt="Custom Timbuk2 backpack on a cement surface during golden hour, featuring lavender, brown, and black color panels.")
		
</template>

<style></style>